<template>
<div class="dialog-msg">
    <div class="dialogconf-content">
       <select-column :values="listDatas" @select="selectNewIndex"/>
    </div>
    <div class="dialogmsg-bottom">
        <button class="mt-btn__type3 dialogbtn-no" type="button" v-on:click="noCallbackFunction"   :style="{color:leftColor}"> {{noText}} </button>
        <button class="mt-btn__type1 dialogbtn-yes" type="button" v-on:click="yesCallbackFunction" :style="{color:rightColor}" style="padding-right:1rem" >  {{yesText}}  </button>
    </div>
</div>
</template>

<script>
import SelectColumn from '../iosSelect/SelectColumn.vue';
export default {
  components: { SelectColumn },
    name: 'dialog-message',
    props:{
        message:{
            type:String,
            required:true,
        },
        options:{
            type:Object,
            required:true,
        },
    },
    data () {
        return {
            isShowDetail:false,
            levelNum:20,
            iClass:'dialogicon-1',
            detailClass:'dialogbtn-ddown',
            overflow:'hidden',
            selectIndex:-1,
            listDatas:[],
            yesText: this.$t('common.confirm'),//'确认'
            noText:this.$t('common.cancel'),//'取消',

            leftColor:'#333',
            rightColor:'#333',
        }
    },
    mounted () {
        console.log(this.options);
        if(this.options&&this.options.yesText){
            this.yesText=this.options.yesText;
        }
        if(this.options&&this.options.noText){
            this.noText=this.options.noText;
        }
        if(this.options&&this.options.leftColor){
            this.leftColor=this.options.leftColor;
        }
        if(this.options&&this.options.rightColor){
            this.rightColor=this.options.rightColor;
        }
         if(this.options&&this.options.listData){
            this.listDatas=this.options.listData;
        }
        console.log('this.listDatas=',this.listDatas)
        this.iClass="dialogicon-"+this.iType;
    },
    methods: {
        selectNewIndex(index){
            console.log('selectNewIndex',index)
            if(index!=this.selectIndex){
                this.selectIndex=index;
            }
        },
        yesCallbackFunction () {
            try{
                if(this.options&&typeof this.options.yesCallbackFunction === "function"){
                    let result=this.options.yesCallbackFunction(this.selectIndex);
                    if (typeof result == "boolean" && result == false) {
                        return;
                    }
                }
            }
            catch(e){
            }
            this.closeDialog();
        },
        noCallbackFunction(){
            try{
                if(this.options&&typeof this.options.noCallbackFunction === "function"){
                    let result=this.options.noCallbackFunction(this.selectIndex);
                    if (typeof result == "boolean" && result == false) {
                        return;
                    }
                }
            }
            catch(e){
            }
            this.closeDialog();
        },
        closeDialog(){
            this.confirmData=null;
            this.$parent.closedialog();
        }
    },
}
</script>